import { Divider } from '@scaleaq/scaleui';
import styled from 'styled-components';

export const StyledDataRowDivider = styled(Divider)<{ $spacing: string }>`
  margin-top: ${({ $spacing }) => $spacing};
  margin-bottom: ${({ $spacing }) => $spacing};
`;
